import { Injectable } from '@angular/core';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { MailingHistoryPageInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-history-page.dto';
import type { MailingSearchQueryInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-search-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MailingService extends BaseService {
  protected baseUrl = '/basis/notification/mailing';

  public run(queryParams: MailingSearchQueryInterface): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/run`, { params: this.objectToHttpParams(queryParams) });
  }

  public runById(id: number): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/${id}/run`);
  }

  public historyById(id: number, queryParams: PaginationQueryInterface): Observable<MailingHistoryPageInterface> {
    return this.http.get<MailingHistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
